import React from 'react';
import styled from 'styled-components';
import Collapsible from '../Collapsible';
import EditorStringComponent from '../EditorString/EditorString';
import { text, fontFamilyBold } from '../../styling/mixins/typography';
import LipscoreRating from '../Lipscore/LipscoreRating';

import BrandTab from './Tabs/BrandTab';
import ReviewsTab from './Tabs/ReviewsTab';
import SpecificationTab from './Tabs/SpecificationTab';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import TabItem from '../../Types/TabItem';
import { BRAND_TYPE, EDITOR_TYPE, REVIEWS_TYPE } from './ProductTabsConstants';


interface ProductMobileTabsProps {
  activeTab?: string;
  specification: any;
  specifications: { key: string; value: any };
  hasVariants: boolean;
  tabItems: TabItem[];
}

const StyledProductMobileTabs = styled.div`
  .collapsible {
    label, 
      .toggle-collapsible {
      ${text('large')};
      ${fontFamilyBold};
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    .ReactCollapse--content {
      padding-left: 1.6rem !important;
      padding-right: 1.6rem !important;
      padding-bottom: 2.4rem;
    }
  }
`;

const StyledReviewsLabel = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-right: 1rem;
  width: 100%;
`;

const ProductTabsContainerMobile = ({
  specification,
  specifications,
  hasVariants,
  tabItems
}: ProductMobileTabsProps) => {
  const { articleNumber } = useTypedSelector((state) => state.buyButton);
  var variantspecifications =
    articleNumber && articleNumber.length > 0 && specifications
      ? specifications[articleNumber]
      : specification;

  const getLabelByType = (type: string, label: string, value: any) => {
    switch (type) {
      case REVIEWS_TYPE:
        return <StyledReviewsLabel>{label}<LipscoreRating productModel={value.productModel} readOnly={true} /></StyledReviewsLabel>
      default:
        return label
    }
  }

  const getComponentByType = (type: string, value: any) => {
    switch (type) {
      case BRAND_TYPE:
        return <BrandTab brand={value} />
      case REVIEWS_TYPE:
        return <ReviewsTab productModel={value.productModel} readOnly={true} />
      case EDITOR_TYPE:
        return <EditorStringComponent value={value} />
    }
  }

  return (
    <StyledProductMobileTabs>

      {tabItems.map(({ key, value, type, label }) => {
        type = type.toUpperCase();

        return (
          <Collapsible isOpen={key === "description" ? true : undefined} label={getLabelByType(type, label, value)} >
            {getComponentByType(type, value)}
          </Collapsible >
        )
      })}
      {
        variantspecifications?.productFields?.length >= 1 && (
          <Collapsible label={translate('product-tabs.specification')}>
            <SpecificationTab
              specifications={variantspecifications}
              showSpecificationsDefaultText={
                hasVariants && (!articleNumber || articleNumber.length < 1)
              }
            />
          </Collapsible>
        )
      }
    </StyledProductMobileTabs >
  );
};

export default ProductTabsContainerMobile;